import { firebase } from "@data/firebase/config";
import { doc, onSnapshot } from "firebase/firestore";

import DatabaseImportJobRepository from "@domain/repositories/DatabaseImportJobRepository";
import { ImportJobStore } from "@domain/stores/ImportJobStore";
import { ImportJob } from "@domain/models/ImportJob";

export class FirebaseImportJobRepository implements DatabaseImportJobRepository {
  COLLECTION = "importJobs";

  constructor(private readonly importJobStore: ImportJobStore) {}

  watchPendingImports(jobId: string) {
    const consulta = doc(firebase.db, this.COLLECTION, jobId);
    onSnapshot(
      consulta,
      async (doc) => {
        const data = {
          ...doc.data(),
          id: doc.id,
        } as ImportJob;

        this.importJobStore.updateImportJob(data);
      },
      (error) => console.log("watchPendingImports error", error)
    );
  }
}
